import { useState, useCallback } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import ToastSystem from "../components/ToastSystem";
import { INITIAL_PRODUCTS, INITIAL_USERS } from "../data/constants";

export default function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [products, setProducts] = useState(INITIAL_PRODUCTS);
  const [users, setUsers] = useState(INITIAL_USERS);
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = "info") => {
    setToasts((prev) => {
      // Skip if the same message is already showing — repeated triggers
      // (e.g. holding a key on a locked input) shouldn't stack duplicates.
      if (prev.some((t) => t.message === message && t.type === type)) return prev;
      const id = Date.now();
      setTimeout(() => setToasts((p) => p.filter((t) => t.id !== id)), 3500);
      return [...prev, { id, message, type }];
    });
  }, []);

  return (
    <div className="app flex h-screen overflow-hidden bg-[#f0f2f5] relative">
      <Sidebar 
        collapsed={collapsed} 
        setCollapsed={setCollapsed} 
        mobileOpen={mobileSidebarOpen} 
        setMobileOpen={setMobileSidebarOpen} 
      />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <Header onMenuClick={() => setMobileSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto px-4 md:px-6 pb-6 bg-[#f0f2f5]">
          <Outlet context={{ products, setProducts, users, setUsers, addToast }} />
        </main>
      </div>
      <ToastSystem toasts={toasts} />
    </div>
  );
}
